import { LISBlock } from "pwapi";

import SegmentedControl, {
  onChangeForPieceCount,
  optionsForPieceCount,
} from "./SegmentedControl";

export const GrossPieceCountControl = ({
  block,
  onChange,
}: {
  block: Partial<LISBlock>;
  onChange: Function;
}) => {
  return (
    <div className="Block__input__container">
      <label>Gross Piece Count</label>
      <SegmentedControl
        options={optionsForPieceCount(
          Object.values(LISBlock.piece_count),
          block.piece_count
        )}
        name={`piece_count_${block.id}`}
        onChange={onChangeForPieceCount(block.piece_count, (pieceCount) =>
          onChange(block.id, pieceCount)
        )}
      />
    </div>
  );
};
